import { jsx } from 'react/jsx-runtime';
import { getDefaultRadixPortalContainer } from '@fabric-app/compat';
import { cssVar } from '../../theme/variables.js';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { styled } from 'styled-components';

const PopoverRoot = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const StyledContent = styled(PopoverPrimitive.Content).withConfig({
  displayName: "Popover__StyledContent",
  componentId: "sc-9c6c288f-0"
})([
  `z-index:50;width:18rem;border:1px solid `,
  `;border-radius:5px;background-color:`,
  `;padding:1rem;color:`,
  `;box-shadow:0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -4px rgba(0,0,0,0.1);outline:none;&[data-state='open']{visibility:visible;pointer-events:auto;}&[data-state='closed']{visibility:hidden;pointer-events:none;}`
], cssVar["color-border-primary"], cssVar["color-bg-primary"], cssVar["color-text-primary"]);
const PopoverContent = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ jsx(PopoverPrimitive.Portal, {
  container: getDefaultRadixPortalContainer(),
  children: /* @__PURE__ */ jsx(StyledContent, {
    ref,
    ...props
  })
}));
PopoverContent.displayName = "PopoverContent";
const Popover = Object.assign(PopoverRoot, {
  Trigger: PopoverTrigger,
  Content: PopoverContent
});

export { Popover as default };
//# sourceMappingURL=Popover.js.map
